import React from 'react';
import { Label } from 'reactstrap';

export const CommonLabel = ({ htmlFor, className = "form-label", children, isRequired = false }) => {
    return (
        <Label htmlFor={htmlFor} className={className}>
            {children}
            {isRequired && <span className="text-danger"> *</span>}
        </Label>
    );
};


